<span
  class="inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-semibold"
  [ngClass]="classes[status]"
>
  {{ 'crm_tasks.status.' + status | translate }}
</span>
